import { deleteDeleteAppointment } from "@Services/reservation/deleteReserve.service";

export const deleteDeleteAppointment_adapter = async (id: number) => {
  const response = await deleteDeleteAppointment(id);
  return response;
};
